export const INTERNET_CONNECTION_MEASURE_SPEED_START = 'INTERNET_CONNECTION_MEASURE_SPEED_START';
export const INTERNET_CONNECTION_MEASURE_SPEED_SUCCESS = 'INTERNET_CONNECTION_MEASURE_SPEED_SUCCESS';
export const INTERNET_CONNECTION_MEASURE_SPEED_FAILURE = 'INTERNET_CONNECTION_MEASURE_SPEED_FAILURE';

export const INTERNET_CONNECTION_INIT_START = 'INTERNET_CONNECTION_INIT_START';
export const INTERNET_CONNECTION_INIT_SUCCESS = 'INTERNET_CONNECTION_INIT_SUCCESS';

export const INTERNET_CONNECTION_CHANGE = 'INTERNET_CONNECTION_CHANGE';

export const CONNECTION_STATUS_NAMES = {
    DISCONNECTED: 'disconnected',
    CONNECTING: 'connecting',
    CONNECTED: 'connected',
} as const;
